module.exports = __webpack_public_path__ + "img/pitching9.8b202f6d.png";